import {getUserConfig} from "@utility/utils";

const initialState = {
    list: [],
    total: 0,
    loading: false,
    searchParams: {
        refresh: false,
        gameIDs: "",
        status: "",
        userID: "",
        start_date: "",
        end_date: "",
        page: 1,
        count: 30,
        ...getUserConfig("loop2Notice")
    },
    loopSetting: {
        list: [],
        total: 0,
        loading: false,
        submitting: false,
    }
}

const loop2Reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'LOOP2_DATA':
            return {
                ...state,
                ...action.payload
            }
        case 'LOOP2_DATA_RELOAD':
            return {
                ...state,
                searchParams: {
                    ...state.searchParams,
                    refresh: true
                }
            }
        case 'LOOP2_DATA_INIT':
            return {
                ...initialState,
                searchParams: {
                    ...initialState.searchParams,
                    ...getUserConfig("loop2Notice")
                }
            }
        case 'LOOP2_SETTING_DATA':
            return {
                ...state,
                loopSetting: {
                    ...state.loopSetting,
                    ...action.payload
                }
            }
        default:
            return {...state};
    }
}

export default loop2Reducer
